export const competitiveTerritories = {
  "competitiveTerritories.view": "competitiveTerritories.view",
  "competitiveTerritories.create": "competitiveTerritories.create",
  "competitiveTerritories.edit": "competitiveTerritories.edit",
} as const;
